import { rpApi } from "@/http";

type ApiGetResult = ReturnType<typeof rpApi.get>;
type ApiPostResult = ReturnType<typeof rpApi.post>;

export default {
  getSimpleInfo(id: string): ApiGetResult {
    return rpApi.get("/treasure/v1/hotspots/simpleInfo", { id });
  },
  getSectionInfo(entryId: string): ApiGetResult {
    return rpApi.get("/treasure/flora/v2/hotspot/section/info", { entryId });
  },
  getFeeds(params: {
    andTagIds: string[];
    entryType: string;
    mediaAttachment: boolean;
    orderBy: string;
    style: string;
    limit: number;
    offset: number;
  }): ApiPostResult {
    return rpApi.post("/gactus/posts/by-tag-v4", params);
  },
};
